import coreRenderWebChat from '../../../renderWebChat';
import { ReactWebChat } from '../component/minimal';

const renderWebChat = coreRenderWebChat.bind(null, ReactWebChat);

export { renderWebChat };
